import * as React from "react";

import SyntaxHighlighter from 'react-syntax-highlighter';
import { Typography } from "@mui/material";

// function listItem(item: string, descr: string): any {
//     return (
//         <ListItem component={'span'} key={item}>
//             <ListItemText secondary={descr} primary={item}/>
//         </ListItem>
//     )
// }

const SubmissionHelpText = (
    <div>
        <Typography variant={"h5"} gutterBottom>
            Unique submission ID
        </Typography>
        <Typography variant={"body1"} gutterBottom>
            Submission ID is a unique identifier for your submission.
            Default for submission ID is affilliation_experiment_cruise. 
            It can be edited by submitter during the submission process.
        </Typography>

        <Typography variant={"h5"} gutterBottom>
           Submission path
        </Typography>
        <Typography variant={"body1"} gutterBottom>
           The submission path helps you organising your data. It is defined as:
           <SyntaxHighlighter language='javascript'>
               AFFILIATION/EXPERIMENT/CRUISE
           </SyntaxHighlighter>
        </Typography>


        <Typography variant={"h5"} gutterBottom>
            Publication date
        </Typography>
        <Typography variant={"body1"} gutterBottom>
            The aim of this database is to provide your data to the public. However, you can control the publication.
            If the "Publish Data" option is not checked, data will not be published. You can also delay the
            publication by checking "Publish Data", but set a specific date.
            If the submitter has requested a DOI this property will be set and can only be changed by an admin.
        </Typography>
        <Typography variant={"h5"} gutterBottom>
            DOI
        </Typography>
        <Typography variant={"body1"} gutterBottom>
            The Digital Object Identifier (DOI) referring to the submitted datasets.
            A valid DOI always starts with "10.".
            If the submitter requested a DOI to be assigned to the submission by the admin, 
            this will show "requested" until a DOI could be created and assigned to the submission.
            If the submission does not qualify for a DOI this will show "rejected". 
            In that case the user will be contacted to resolve the issue.
            Finally, after communication with submitter, the status "requested" should be removed by DOI admin.
        </Typography>
        <Typography variant={"h5"} gutterBottom>
            Requester Email
        </Typography>
        <Typography variant={"body1"} gutterBottom>
            Contact information of submitter in case of a need to resolve issues regarding the submission.
        </Typography>
        <Typography variant={"h5"} gutterBottom>
            Publish Data
        </Typography>
        <Typography variant={"body1"} gutterBottom>
            Checked whether submitted datasets should be made publicly available as of the specified publication date.
            If the submitter requested a DOI for the submission, the data must be published. 
            In this case, the checkbox is automatically selected and cannot be changed.
        </Typography>
    </div>
);

export default SubmissionHelpText;
